// src/locales/si/messageCenterShifts.js
export const messageCenterShifts = {
  pageTitle: 'මැසේජ් සෙන්ටර් මුරප්පාර',
  pageDescription: 'මුරප්පාර සකසන්න, නායකයෙකු සහ කාර්ය මණ්ඩලය පවරන්න, වැඩ කරන වේලා නිරීක්ෂණය කරන්න',
  newShift: 'නව මුරය',
  editShift: 'මුරය සංස්කරණය කරන්න',
  createShift: 'මුරය සාදන්න',
  saveShift: 'මුරය සුරකින්න',
  shiftDate: 'මුර දිනය',
  shiftType: 'මුර වර්ගය',
  shiftLeader: 'මුර නායක',
  targetSalesValue: 'ඉලක්ක විකුණුම් අගය',
  commissionFlags: 'කොමිස් සලකුණු',
  excludeAllFromCommission: 'සියලුම කාර්ය මණ්ඩලය කොමිසමෙන් බැහැර කරන්න',
  excludeLeaderFromCommission: 'නායකයා කොමිසමෙන් බැහැර කරන්න',
  shiftStaff: 'මුර කාර්ය මණ්ඩලය',
  addStaff: 'කාර්ය මණ්ඩලය එකතු කරන්න',
  staffMember: 'කාර්ය මණ්ඩල සාමාජිකයා',
  startTime: 'ආරම්භක වේලාව',
  endTime: 'අවසන් වේලාව',
  staffCount: 'කාර්ය මණ්ඩල ගණන',
  achievedSalesValue: 'ලබාගත් විකුණුම්',
  totalCommission: 'මුළු කොමිසම',
  detailsPageTitle: 'මුර විස්තර',
  detailsPageDescription: 'මෙම මුරයේ කොමිස් වර්ගීකරණය, ඇණවුම් සහ කාර්ය සාධන සාරාංශය',
  totalOrders: 'මුළු ඇණවුම්',
  dispatchedOrders: 'යවන ලද ඇණවුම්',
  settledOrders: 'පියවන ලද ඇණවුම්',
  salesValue: 'විකුණුම් අගය',
  orderQuantity: 'ඇණවුම් ප්‍රමාණය',
  itemQuantity: 'අයිතම ප්‍රමාණය',
  staffCommissionBreakdown: 'කාර්ය මණ්ඩල කොමිස් වර්ගීකරණය',
  shiftOrders: 'මුර ඇණවුම්',
  noOrdersForShift: 'මෙම මුරයට අයත් ඇණවුම් නොමැත',
  failedToLoadShiftDetails: 'මුර විස්තර පූරණය කිරීමට අසමත් විය',
  failedToLoadShiftOrders: 'මුර ඇණවුම් පූරණය කිරීමට අසමත් විය',
  hours: 'පැය',
  courierStatus: 'කූරියර් තත්ත්වය',
  orderItems: 'Order Items',
  itemsQty: 'Qty',
  commissionCalculation: 'කොමිස් ගණනය කිරීම',
  amountPerUnit: 'ඒකකයකට මුදල',
  slabQty: 'ස්ලැබ් ප්‍රමාණය',
  slabTotal: 'ස්ලැබ් එකතුව',
  searchShiftOrders: 'ඇණවුම් අංකය, පාරිභෝගිකයා, එයාර්වේබිල් හෝ දුරකථනය සොයන්න...',
  orderStatusFilter: 'ඇණවුම් තත්ත්වය',
  courierStatusFilter: 'කූරියර් තත්ත්වය',
  allStatuses: 'සියලු තත්ත්වයන්',
  searchStatuses: 'තත්ත්වයන් සොයන්න...',
  filterByShiftType: 'මුර වර්ගය අනුව පෙරහන් කරන්න',
  filterByLeader: 'නායකයා අනුව පෙරහන් කරන්න',
  allShiftTypes: 'සියලුම මුර වර්ග',
  allLeaders: 'සියලුම නායකයින්',
  dateFrom: 'සිට දිනය',
  dateTo: 'දක්වා දිනය',
  filterByDateRange: 'මුර දින පරාසය',
  allShiftDates: 'සියලුම මුර දින',
  noShiftsFound: 'මුරප්පාර හමු නොවීය',
  noShiftsFoundDescription: 'ඔබගේ පෙරහන් සකස් කරන්න හෝ නව මුරයක් සාදන්න',
  noShiftsYet: 'තවම මුරප්පාර සකසා නැත',
  noShiftsYetDescription: 'ආරම්භ කිරීමට ඔබගේ පළමු මුරය සාදන්න',
  shiftCreatedSuccess: 'මුරය සාර්ථකව සාදන ලදී',
  shiftUpdatedSuccess: 'මුරය සාර්ථකව යාවත්කාලීන කරන ලදී',
  failedToLoadShifts: 'මුරප්පාර පූරණය කිරීමට අසමත් විය',
  failedToLoadShiftTypes: 'මුර වර්ග පූරණය කිරීමට අසමත් විය',
  failedToLoadUsers: 'ව්‍යාපාරික පරිශීලකයින් පූරණය කිරීමට අසමත් විය',
  failedToSaveShift: 'මුරය සුරැකීමට අසමත් විය',
  timesResetNote: 'ආරම්භක/අවසන් වේලාවන් තෝරාගත් මුර වර්ගයේ පෙරනිමි වේලාවන්ට යාවත්කාලීන කර ඇත.',
  selectShiftType: 'මුර වර්ගයක් තෝරන්න',
  selectLeader: 'මුර නායකයෙකු තෝරන්න',
  selectUser: 'පරිශීලකයෙකු තෝරන්න',
  removeStaff: 'ඉවත් කරන්න',
  duplicateStaffWarning: 'මෙම පරිශීලකයා දැනටමත් මෙම මුරයට එකතු කර ඇත',
  leaderStaffRowUpdatedNotice: 'නව නායකයාට ගැලපෙන පරිදි මුර නායකයාගේ කාර්ය මණ්ඩල පේළිය යාවත්කාලීන කර ඇත',
  leaderRowLocked: 'මෙම පරිශීලකයා මුර නායකයා බැවින් මෙම පේළිය ස්වයංක්‍රීයව කළමනාකරණය වේ',
  edit: 'සංස්කරණය',
  viewDetails: 'විස්තර බලන්න',
  estimate: 'Estimate',
  estimateNote: 'Live estimate — commission values will be final once the shift is finalized',
  selectTime: 'Select time',
  targetSalesValuePlaceholder: 'e.g. 500000',
  validation: {
    shiftDateRequired: 'මුර දිනය අවශ්‍යයි',
    shiftTypeRequired: 'මුර වර්ගය අවශ්‍යයි',
    shiftLeaderRequired: 'මුර නායකයා අවශ්‍යයි',
    targetSalesValueRequired: 'ඉලක්ක විකුණුම් අගය අවශ්‍යයි',
    targetSalesValueInvalid: 'ඉලක්ක විකුණුම් අගය වලංගු ධන සංඛ්‍යාවක් විය යුතුය',
    staffUserRequired: 'සෑම පේළියක් සඳහාම කාර්ය මණ්ඩල සාමාජිකයෙකු තෝරන්න',
    staffTimeRequired: 'සෑම කාර්ය මණ්ඩල පේළියක් සඳහාම ආරම්භක සහ අවසන් වේලාව අවශ්‍යයි',
    fixErrors: 'සුරැකීමට පෙර දක්වා ඇති දෝෂ නිවැරදි කරන්න',
  },
};
